import React from 'react';

import fetch from '../../../fetch';

import moment from 'moment';

import { Modal, Popover } from 'antd';

import explicate from '../../../../viewport/scientificResearch/Explicate';

import {ky_constant} from '../../../../viewport/scientificResearch/Constant'

import reqwest from 'reqwest';

const DataGrid = {
    selections: [],
    resultStateSelections: [],
    refresh: function () {

    }
}

const projectData = {
    projectIds: []
}

const headers = [
    { type: 'selection' },
    { key: '$index', label: '序号', width: 40 },
    {
        key: 'projectName', label: '项目名称', width: 150,
        render: (value, row) =>
            <span>
                <Popover style={{ width: 300 }} content={
                    <div style={{ width: 200 }}>
                        {
                            value
                        }
                    </div>}
                >
                    {<a style={{ color: '#24619a' }} href="javascript:;">{value}</a>}
                </Popover>
            </span>
    },
    { key: 'unitName', label: '所属单位', width: 100 },
    {
        key: 'chargerName', label: '负责人', width: 80, render: (value, row) =>
            <span>
                <Popover style={{ width: 300 }} content={

                    <div style={{ width: 200 }}>
                        <div>
                            工号： {row.chargerCode || ""}
                        </div>
                        <div>
                            名称： {value || ""}
                        </div>
                    </div>}
                >
                    {<a style={{ color: '#24619a' }} href="javascript:;">{value}</a>}
                </Popover>
            </span>
    },
    { key: 'projectTypeName', label: '项目分类', width: 100 },
    { key: 'acceptanceType', label: '验收类别', width: 100, render:(value) => explicate.getAcceptanceType(value) },
    { key: 'authorizeDate', label: '立项日期', width: 100, render: (value) => value ? moment(new Date(value)).format('YYYY/MM/DD') : "" },
    { key: 'completeDate', label: '结项日期', width: 100, render: (value) => value ? moment(new Date(value)).format('YYYY/MM/DD') : "" },

    {
        key: 'checkStatus', label: '审核状态', width: 90, render: (d) => {
            let status = ''
            if (d === ky_constant.DEPARTMENT_RETURNED.key || d === ky_constant.SCHOOL_RETURNED.key || d === ky_constant.REPEAL.key) {
                status = <div style={{ color: '#d83232' }}>{explicate.getCheckStatus(d)}</div>
                
            } else {
                status = explicate.getCheckStatus(d)
            }
            return status
        }
    },
];



/**
 * @method querySearch
 * @param {object} [keywords]
 * @return {promise}
 */
const querySearch = (keywords = { pageNum: 1, pageSize: 100 }) => {
    const session = JSON.parse(sessionStorage.session || '{"account": {}}')
    const account = session.account;

    const defaultsParams = {
        bgTermId: account.termId,
        endTermId: account.termId
    };
    return fetch.post('ky/project/portrait/examine/complete/department/list', Object.assign(defaultsParams, keywords))
        .then(response => {
            projectData.projectIds = []
            projectData.projectIds = (response.payload.data.dataList || []).map(d => {
                return {
                    value: d.id,
                    Key: d.id,
                    projectId: d.projectId
                }
            })
            return {
                data: response.payload.data,
                meta: response.payload.meta
            };
        })
        .then(response => (Object.assign({
            result: (response.data.dataList || []).map(item => {
                return Object.assign(item, {
                    backFlag: response.backFlag,
                })
            }),
            selects: (response.data.dataList || []).map(d => ({
                value: d.id,
                Key: d.id,
                checked: false
            })),
            meta: response.meta,
            checked: false,
            total: response.data.total,
            pageIndex: response.data.pageNum,
            pageSize: response.data.pageSize,
            notify: (response.data.dataList || []).length ? '' : '暂无数据...'
        })));
}

/**
 * @method onSelect
 * @param {array} ids [id: int, ...]
 * @return {promise}
 */
const onSelect = (ids) => {
    DataGrid.selections = ids;
}

/**
 * @method onSelect
 * @param {array} ids [id: int, ...]
 * @return {promise}
 */
const onResultStateSelect = (ids) => {
    DataGrid.resultStateSelections = ids;
}

/**
 * @method onSelect
 * @param {array} ids [id: int, ...]
 * @return {promise}
 */
const getResultStateSelect = () => {
    return DataGrid.resultStateSelections;
}

/**
 * @method setRefresh
 * @param {function} callback
 * @return {promise}
 */
const setRefresh = (callback) => {
    DataGrid.refresh = callback;
};

/**
 * @method redirect
 * @param {string} url
 * @return {void}
 */
const redirect = (url) => {
    window.location.hash = 'eval/result' + url;
};

const getSelection = () => {
    return DataGrid.selections;
}

const examine = (examineData) => {
	return fetch.post('ky/project/portrait/examine/complete/department/examine', examineData)
		.then(response => {
			if(response.code === 200) {
				Modal.success({
					title: '项目结项审核',
					content: '项目结项审核成功',
					onOk:() => {
					}
				});
			} else {
				Modal.error({
					title: '项目结项审核',
					content: response.message,
					onOk:() => {
					}
				});
			}
		});
}

const getProjectIds = (value) => {
    let projectId = undefined
    projectData.projectIds.forEach(e => {
        if (e.value === value) {
            projectId = e.projectId
        }
    })
    return projectId;
}

export default {
    querySearch,
    headers,
    onSelect,
    setRefresh,
    redirect,
    getSelection,
    onResultStateSelect,
    getResultStateSelect,
    examine,
    getProjectIds
}